import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/live/detail',
  name: 'LiveDetail',
  component: function component() {
    return import('@/pages/live/live-detail');
  }
}, {
  path: '/live/channel',
  name: 'LiveChannel',
  component: function component() {
    return import('@/pages/live/live-channel');
  }
}, {
  path: '/live/watch',
  name: 'LiveWatch',
  component: function component() {
    return import('@/pages/live/live-watch');
  }
}];